var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subscene",style:({zIndex: _vm.scene.pos.zIndex, left: ((_vm.scene.pos.x) + "%"), top: ((_vm.scene.pos.y) + "%")})},[_c('img',{attrs:{"src":this.scene.imageSmall,"alt":"tile"}})])}
var staticRenderFns = []

export { render, staticRenderFns }